<template>
  <div class="validate-question">
    <div>
      <img v-if="node.question.image !== null" :src="node.question.image" class="question-image" />
      <p v-if="node.prompt !== null" v-html="node.prompt"></p>
      <div v-html="node.question.instructions"></div>
      <v-text-field
        id="text-input"
        v-model="content"
        outlined
        :type="node.question.input_type"
        :hint="node.question.help_text"
        persistent-hint
      ></v-text-field>
      <v-btn class="submit-button" color="secondary" @click="onValidate">
        Validate
      </v-btn>
      <p v-if="processing == true" class="processing">
        <img src="../assets/gear.gif" alt="processing..." class="busy" />
        Please wait, validating...
      </p>
      <p v-if="message !== null" class="message">{{ message }}</p>
    </div>
    <div class="buttons">
      <v-btn
        class="submit-button"
        :disabled="!isValidSelection()"
        color="primary"
        @click="onAnswerQuestion"
      >
        {{ submitButton }}
      </v-btn>
      <v-btn v-if="node.skippable" class="submit-button" color="secondary" @click="onSkipQuestion">
        {{ skipButton }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ValidateQuestion',
  data() {
    return {
      content: null,
      valid: false,
      message: null,
      processing: false,
    };
  },
  methods: {
    isValidSelection() {
      return this.valid;
    },
    onValidate() {
      this.processing = true;
      this.message = null;
      axios
        .post(this.node.question.validation_api, { content: this.content })
        .then((res) => {
          this.valid = res.data.valid;
          this.message = res.data.message;
          this.processing = false;
        })
        .catch((e) => {
          this.processing = false;
          this.valid = false;
          this.message = `Problem validating your information - ${e}. Please contact support.`;
        });
    },
    onAnswerQuestion() {
      this.$emit('answer', { node: this.node, text: this.content });
      this.content = null;
    },
    onSkipQuestion() {
      this.$emit('skip');
      this.content = null;
    },
  },
  props: {
    node: Object,
    submitButton: String,
    skipButton: String,
  },
  mounted() {
    document.getElementById('text-input').focus();
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_variables.scss';

.validate-question {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;

  .processing {
    margin-top: 10px;
  }

  .busy {
    height: 16px;
  }

  .message {
    margin-top: 10px;
  }

  .question-image {
    display: block;
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
  }
}

@media (min-width: $breakpoint-tablet) {
  .validate-question {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }
  }
}
</style>
